import styled from 'styled-components'
import { media } from '../config/settings/media'

export const PageSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  margin-top: 1rem;

  ${media.md`
    gap: 1rem;
    margin-top: 0.5rem;
  `}
`

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  margin-top: 0.15rem;
`

export const SectionTitle = styled.h2`
  margin: 0;
  font-size: 1.05rem;
  font-weight: 600;
  line-height: 1.3;
  letter-spacing: -0.01em;
  color: ${({ theme }) => theme.colors.textPrimary};

  ${media.md`
    font-size: 1.125rem;
  `}
`

export const SectionDescription = styled.p`
  margin: 0;
  font-size: 0.8125rem;
  line-height: 1.45;
  color: ${({ theme }) => theme.colors.textMuted};
`

export const NotificationSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;

  ${media.lg`
    flex-direction: row;
    align-items: stretch;
    gap: 1.5rem;
  `}
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  width: 100%;
  min-width: 0;

  ${media.lg`
    flex: 1;
  `}

  ${SectionHeader} {
    margin-top: 0;
  }
`

export const NotificationBox = styled.div`
  width: 100%;
  flex: 1;
  padding: 0.35rem 1.15rem 0.85rem;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  background: ${({ theme }) => theme.colors.background};
  min-height: 160px;
  overflow: hidden;
`

export const UtmPanel = styled.div`
  width: 100%;
  flex: 1;
  min-width: 0;
`

export const NotificationEmpty = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.35rem;
  width: 100%;
  min-height: 160px;
  padding: 1.5rem 1.25rem;
  border-radius: 12px;
  border: 1px dashed ${({ theme }) => theme.colors.borderStrong};
  background: ${({ theme }) =>
    theme.name === 'dark'
      ? theme.colors.background
      : theme.colors.borderSubtle};
`

export const HistoryPanel = styled.div`
  width: 100%;
  min-height: 0;
`

export const EmptyTitle = styled.span`
  font-size: 0.9375rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textSecondary};
`

export const EmptyHint = styled.span`
  font-size: 0.8125rem;
  line-height: 1.45;
  color: ${({ theme }) => theme.colors.textMuted};
`
